import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiPost } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import { usePricebookApi } from './usePricebookApi';
import type { CreateItemDto } from '@/types/pricebook';
import { ITEM_TYPE_TO_BACKEND } from '@/types/pricebook';

export function useCreateItem() {
  const queryClient = useQueryClient();
  const { client, ep } = usePricebookApi();

  return useApiMutation<unknown, CreateItemDto>({
    mutationFn: (dto) => {
      const payload = {
        ...dto,
        type: ITEM_TYPE_TO_BACKEND[dto.type] ?? dto.type,
      };
      return apiPost(client, ep.create(), payload);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pricebookKeys.lists() });
      toast.success('Item created');
    },
  });
}
